import React from "react";
import { Urls } from "../constants/UrlConstants";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { RebrandHelper } from "../helpers/brand/RebrandHelper";

const exitSurvey = {
  Heading: "Let us know what you think...",
  MolDescription: (
    <React.Fragment>
      <p>
        <strong>
          We'd really like to hear what you think of your online experience.
        </strong>
      </p>
      <p>
        By clicking Continue, you agree to participate in the survey by{" "}
        {RebrandHelper.getAxaBrandName()} to help improve their service. The
        survey should take about 5 minutes for you to complete, depending on
        your answers.
      </p>
      <p>
        All data will be kept in the strictest confidence. If you would like any
        further details concerning data protection, please visit{" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.AxaPppPrivacyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          www.axa.co.uk/privacy-policy
        </a>
        .
      </p>
    </React.Fragment>
  ),

  HolDescription: (
    <React.Fragment>
      <p>
        <strong>
          We’d really like to hear what you think of your online experience.
        </strong>
      </p>
      <p>Click Continue to take part in the survey.</p>
      <p>
        By clicking Continue, you agree to participate in the survey by
        Health-on-Line to help improve their service. The survey should take
        about 5 minutes for you to complete, depending on your answers.
      </p>
      <p>
        All data will be kept in the strictest confidence. If you would like any
        further details concerning data protection, please visit{" "}
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.PrivacyUrl.HOL}
          target="_blank"
          rel="noopener noreferrer"
        >
          www.health-on-line.co.uk/site-services/privacy-legal-cookies
        </a>
        .
      </p>
    </React.Fragment>
  ),

  InternationalDescription: (
    <React.Fragment>
      <p>
        <strong>
          We'd really like to hear what you think of your online service.
        </strong>
      </p>
      <p>Could you spare a few moments to answer 4 questions?</p>
    </React.Fragment>
  ),
  BackLink: "No thanks"
};

export default exitSurvey;
